import classNames from 'classnames';
import { ReactComponent as SpinnerIcon } from 'icons/spinner.svg';

export default function Spinner(props: React.SVGProps<SVGSVGElement>) {
  return <SpinnerIcon {...props} className={classNames('animate-spin-slow', props.className)} />;
}
